import { useEffect, useCallback } from 'react';

// GA4 Measurement ID - Replace with actual ID when available
const GA4_MEASUREMENT_ID = 'G-1SDNB5MS6K';

const AnalyticsManager = () => {
  // Load GA4 script dynamically
  const loadGA4 = useCallback(() => {
    // Check if already loaded
    if (window.gtag) {
      console.log('[Analytics] GA4 already initialized');
      return;
    }

    console.log('[Analytics] Loading GA4...');

    // Create and append the gtag script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA4_MEASUREMENT_ID, {
      anonymize_ip: true,
      cookie_flags: 'SameSite=None;Secure'
    });

    console.log('[Analytics] GA4 initialized successfully');
  }, []);

  useEffect(() => {
    // Check initial consent state
    const checkAndLoadAnalytics = () => {
      const consent = localStorage.getItem('jfi_cookie_consent');
      if (consent) {
        try {
          const prefs = JSON.parse(consent);
          if (prefs.analytics === true) {
            loadGA4();
          } else {
            console.log('[Analytics] User has denied analytics cookies');
          }
        } catch (e) {
          console.log('[Analytics] Invalid consent data');
        }
      } else {
        console.log('[Analytics] No consent recorded yet - analytics blocked');
      }
    };

    // Check on mount
    checkAndLoadAnalytics();

    // Listen for consent changes
    const handleConsentChange = (event) => {
      const { analytics } = event.detail;
      if (analytics === true) {
        loadGA4();
      } else {
        console.log('[Analytics] Analytics consent revoked - will not load GA4');
        // Note: GA4 cannot be "unloaded" once loaded, but it won't track new sessions
        // on page refresh if consent is revoked
      }
    };

    window.addEventListener('jfi-consent-change', handleConsentChange);

    return () => {
      window.removeEventListener('jfi-consent-change', handleConsentChange);
    };
  }, [loadGA4]);

  // This component doesn't render anything
  return null;
};

export default AnalyticsManager;
